<div [ngClass]="theme" class="custom-dialog">
    <mat-dialog-content>
        <!-- Loading State -->
        <div *ngIf="loading" class="loading">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Loading...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="error && !uploading && !processing" class="error">
            <mat-icon color="warn">error</mat-icon>
            <p>{{ error }}</p>
        </div>

        <!-- Main Content -->
        <div *ngIf="!loading" class="dialog-content">
            <!-- Header -->
            <div class="header-section">
                <div class="dialog-header">
                    <mat-icon class="section-icon">upload_file</mat-icon>
                    <h3>Roster Management</h3>
                </div>
            </div>

            <!-- Upload Section -->
            <div class="content-window-l1">
                <h5>Upload Current Roster</h5>
                
                <div class="content-window-l2">
                    <!-- Upload States -->
                    <div *ngIf="!uploading && !processing && !uploadComplete" class="upload-section">
                        <div class="file-input-section">
                            <input #fileInput 
                                   type="file" 
                                   id="rosterFileInput"
                                   accept=".xlsm" 
                                   (change)="onFileSelected($event)"
                                   style="display: none;">
                            
                            <button mat-raised-button 
                                    color="primary" 
                                    (click)="fileInput.click()"
                                    class="file-select-button">
                                <mat-icon>attach_file</mat-icon>
                                Select Excel File (.xlsm)
                            </button>
                            
                            <span *ngIf="selectedFile" class="selected-file">
                                {{ selectedFile.name }}
                            </span>
                        </div>
                        
                        <button mat-raised-button 
                                color="accent" 
                                [disabled]="!selectedFile"
                                (click)="uploadRoster()"
                                class="upload-button">
                            <mat-icon>cloud_upload</mat-icon>
                            Upload Roster
                        </button>
                    </div>

                    <!-- Uploading State -->
                    <div *ngIf="uploading" class="progress-section">
                        <div class="progress-content">
                            <mat-spinner diameter="30"></mat-spinner>
                            <div class="progress-text">
                                <h6>Uploading roster file...</h6>
                                <p>{{ selectedFile?.name }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Processing State -->
                    <div *ngIf="processing" class="progress-section">
                        <div class="progress-content">
                            <mat-spinner diameter="30"></mat-spinner>
                            <div class="progress-text">
                                <h6>Processing roster data...</h6>
                                <p>Importing shifts into system</p>
                            </div>
                        </div>
                    </div>

                    <!-- Complete State -->
                    <div *ngIf="processComplete" class="success-section">
                        <div class="success-content">
                            <mat-icon color="primary" class="success-icon">check_circle</mat-icon>
                            <div class="success-text">
                                <h6>Roster imported successfully!</h6>
                                <p><strong>{{ shiftsImported }}</strong> shifts imported</p>
                            </div>
                        </div>
                        
                        <button mat-raised-button 
                                color="primary" 
                                (click)="resetUploadState()"
                                class="reset-button">
                            <mat-icon>add</mat-icon>
                            Upload Another Roster
                        </button>
                    </div>

                    <!-- Error in upload/processing -->
                    <div *ngIf="error && (uploading || processing)" class="error-section">
                        <mat-icon color="warn">error</mat-icon>
                        <p>{{ error }}</p>
                        <button mat-raised-button (click)="resetUploadState()">Try Again</button>
                    </div>
                </div>
            </div>

            <!-- Recent Uploads Section -->
            <div class="content-window-l1">
                <div class="section-header">
                    <mat-icon class="section-icon">history</mat-icon>
                    <h5>Recent Uploads</h5>
                    <button mat-icon-button 
                            (click)="loadRecentUploads()" 
                            [disabled]="loadingUploads"
                            matTooltip="Refresh list">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
                
                <div class="content-window-l2">
                    <!-- Loading recent uploads -->
                    <div *ngIf="loadingUploads" class="loading-uploads">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span>Loading recent uploads...</span>
                    </div>

                    <!-- Recent uploads list -->
                    <div *ngIf="!loadingUploads && recentUploads.length > 0" class="uploads-list">
                        <div *ngFor="let upload of recentUploads" class="upload-item">
                            <div class="upload-info">
                                <div class="upload-filename">
                                    <mat-icon class="file-icon">description</mat-icon>
                                    <span class="filename">{{ upload.original_filename }}</span>
                                </div>
                                <div class="upload-details">
                                    <span class="upload-user">{{ upload.user_email }}</span>
                                    <span class="upload-time">{{ formatTimestamp(upload.timestamp) }}</span>
                                </div>
                            </div>
                            <div class="upload-status">
                                <span class="status-chip" 
                                      [class.processed]="upload.processed"
                                      [class.pending]="!upload.processed">
                                    {{ upload.processed ? 'Processed' : 'Pending' }}
                                </span>
                                <div *ngIf="upload.processed && upload.processed_timestamp" 
                                     class="processed-time">
                                    Processed: {{ formatTimestamp(upload.processed_timestamp) }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- No uploads -->
                    <div *ngIf="!loadingUploads && recentUploads.length === 0" class="no-uploads">
                        <mat-icon>inbox</mat-icon>
                        <p>No recent roster uploads found</p>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <!-- Dialog Actions -->
    <mat-dialog-actions align="end">
        <button mat-raised-button (click)="onClose()">Close</button>
    </mat-dialog-actions>
</div>